/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
import HitWrapper from './Hit.style';


function Hit(props) {
  const {
    hit,
    components,
    onClick,
  } = props;

  const onItemClick = () => {
    onClick(hit);
  };

  return (
    <HitWrapper onClick={onItemClick}>
      <components.Highlight hit={hit} attribute="title" />
    </HitWrapper>
  );
}

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
Hit.defaultProps = {
  components: null,
  onClick: _noop,
};
Hit.propTypes = {
  // Required props:
  hit: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  // Optional props:
  // eslint-disable-next-line react/forbid-prop-types
  components: PropTypes.any,
  // Optional methods:
  onClick: PropTypes.func,
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default Hit;
